export function floatFix(amount: number): number {
  return Number(amount.toFixed(2))
}
